import { Avatar, Box, Button, Menu, MenuItem } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function stringAvatar(name) {
  const parts = name.trim().split(" ");
  if (parts.length === 1) {
    return {
      children: parts[0][0].toUpperCase(),
    };
  } else {
    return {
      children: `${parts[0][0]}${parts[1][0]}`.toUpperCase(),
    };
  }
}

const VendorNavbar = () => {
  const [active, setActive] = useState(
    Number(localStorage.getItem("active")) || 1,
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [vendor, setVendor] = useState();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.includes("buyers")) {
      setActive(2);
    } else {
      setActive(1);
    }
  }, [location]);

  useEffect(() => {
    const getUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor?email=${storedUser.username}`,
          {
            headers: { Authorization: `Bearer ${storedUser.accessToken}` },
          },
        );
        setVendor(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getUser();
  }, []);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };
  return (
    <Box
      sx={{
        background: "white",
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
        px: 7,
      }}
    >
      {/* <div>Logo</div> */}
      <Box sx={{ display: "flex", columnGap: 10 }}>
        <Button
          className={
            location.pathname.includes("logistic")
              ? "btn-outlined"
              : "btn-contained"
          }
          sx={{ px: 7, textTransform: 'none !important' }}
          onClick={() => {
            // setActive(1);
            // localStorage.setItem("active", 1);
            navigate("/vendor/dashboard");
          }}
        >
          eRFQ
        </Button>
        {/* <Button
            className={`${active === 2 ? "btn-contained" : "btn-outlined"}`}
            sx={{ px: 7 }}
            onClick={() => {
              setActive(2);
              localStorage.setItem("active", 2);
              navigate("/vendor/dashboard/buyers")
            }}
          >
            Buyers
          </Button> */}

        <Button
          className={
            location.pathname.includes("logistic")
              ? "btn-contained"
              : "btn-outlined"
          }
          sx={{ px: 7, width: 'fit-content' }}
          onClick={() => navigate("/vendor/logistic-dashboard")}
        >
          Logistics RFQ
        </Button>

        <Box sx={{ display: "inline-flex", alignItems: "center", gap: 2 }}>
          {vendor && vendor.name}
          <Avatar
            {...stringAvatar(`${vendor && vendor.name}`)}
            onClick={handleAvatarClick}
            sx={{ cursor: "pointer" }}
          />
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Box>
      </Box>
    </Box>
  );
};

export default VendorNavbar;
